import type {
  GrowthBookSourceInitSettings,
  GrowthBookSourceUpdateSettings,
} from '../../lib/loader';
import {
  type ConfigLoaderInstance,
  createClientFrontendConfigLoader,
  createServerFrontendConfigLoader,
  createClientGrowthBookConfigLoader,
} from '../createLoader';
import type { FrontendConfigurationSchema } from '../../generated/frontend';
import type { GrowthBookSchema } from '../../generated/growthBook';

/**
 * Frontend config store
 */
let frontendConfigInstance: ConfigLoaderInstance<FrontendConfigurationSchema> | null =
  null;

export const getFrontendConfig =
  (): ConfigLoaderInstance<FrontendConfigurationSchema> => {
    if (!frontendConfigInstance) {
      frontendConfigInstance =
        typeof window !== 'undefined'
          ? { loader: createClientFrontendConfigLoader() }
          : { loader: createServerFrontendConfigLoader() };
    }
    return frontendConfigInstance;
  };

/**
 * GrowthBook config store
 */
let growthBookConfigInstance: ConfigLoaderInstance<
  GrowthBookSchema,
  GrowthBookSourceInitSettings,
  GrowthBookSourceUpdateSettings
> | null = null;

export const getGrowthBookConfig = (): ConfigLoaderInstance<
  GrowthBookSchema,
  GrowthBookSourceInitSettings,
  GrowthBookSourceUpdateSettings
> => {
  if (!growthBookConfigInstance) {
    growthBookConfigInstance =
      typeof window !== 'undefined'
        ? { loader: createClientGrowthBookConfigLoader() }
        : {
            loader:
              process.env['NEXT_PHASE'] === 'phase-production-build'
                ? createClientGrowthBookConfigLoader()
                : undefined,
          };
  }
  return growthBookConfigInstance;
};

export const initGrowthBookConfig = async (
  settings: GrowthBookSourceInitSettings,
): Promise<void> => {
  const instance = getGrowthBookConfig();
  return instance.loader?.init(settings);
};

export const updateGrowthBookConfig = async (
  settings: GrowthBookSourceUpdateSettings,
): Promise<void> => {
  const instance = getGrowthBookConfig();
  return instance.loader?.update(settings);
};
